<template>
  <div>
    <!-- 关联商品 -->
    <el-form-item size="small" >
     
      <el-button icon="el-icon-plus" @click="changeProduct(form.product)">选择商品</el-button>
      <div  style="margin-top: 10px;">
        <el-table size="small" :data="form.product" border>
          <el-table-column label="图片" width="60">
       
            <template slot-scope="scope">
              <div class="product-info">
                <div class="pic">
                  <img width="30px" height="30px" v-img-url="scope.row.product_image" alt="product_image"/></div>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="product_name" label="商品"></el-table-column>

          <el-table-column prop="product_price" label="价格"></el-table-column>

          <el-table-column prop="spec_value" label="规格"></el-table-column>

          <el-table-column prop="type" label="类型">
            <template slot-scope="scope">
              <el-radio-group v-model="scope.row.dis_status">
                <el-radio :label="1">固定</el-radio>
                <el-radio :label="2">比例</el-radio>
              </el-radio-group>
          </template>
          </el-table-column>   

          <el-table-column prop="type" label="优惠金额" width="200">
            <template slot-scope="scope">
              <el-input type="number" v-model="scope.row.discounts"></el-input>
            </template>
          </el-table-column>

          <el-table-column prop="type" label="最终金额" width="200">
            <template slot-scope="scope">
              <span v-if="scope.row.dis_status == 1">{{ scope.row.discounts }}元</span>
              <span v-if="scope.row.dis_status == 2">{{ getPrice(scope.row.product_price*scope.row.discounts/100) }}元</span>
           
              </template>
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="90">
            <template slot-scope="scope">
              <el-button @click="deleteClick(scope.$index)" type="text" size="small">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-form-item>
    <!--商品选择-->
    <SkuProduct :isproduct="isproduct" :excludeIds="excludeIds" :islist="islist" @closeDialog="closeDialogFunc"></SkuProduct>

  </div>
</template>

<script>
import SkuProduct from '@/components/product/SkuProduct';
import {mergeTable} from '@/utils/table.js';

export default {
  components: {
    /*选择商品组件*/
    SkuProduct,
  },
  data() {
    return {
      unit: '%',
      isproduct: false,
      /*产品去重*/
      excludeIds: [],
    };
  },
  props: {
    form: Object,
    type: String,
    islist:{
      type:Boolean,
      default:true
    }
  },
  
  methods: {
    roundToDecimalPlace(number, decimalPlaces) {
        const factor = Math.pow(10, decimalPlaces);
        return Math.round(number * factor) / factor;
      },
      getPrice(price){
        console.log("price",this.roundToDecimalPlace(price,2))
        return this.roundToDecimalPlace(price,2)
      },
    /*关闭弹窗*/
    /*关闭弹窗*/
    closeDialogFunc(e) {
      console.log("closeDialogFunc",e)
      let self = this;
      self.isproduct = false;
      if (e.type === 'success') {
        let arr = [];
        for (let i = 0; i < e.params.length; i++) {
          let item = e.params[i];
          arr.push({
            product_name: item.product_name,
            product_id: item.product_id,
            product_sku_id: item.product_sku_id,
            product_price: item.product_price,
            product_image: item.product_image,
            spec_value:item.spec_value,
            spec_sku_id:item.spec_sku_id,
            set_num:1,
            dis_status:1,
            discounts:0,
          });
        }
        self.form.product = self.form.product.concat(arr);
        self.form.product = mergeTable( self.form.product);
    
      }
    },
    /*打开添加*/
    changeProduct(list) {
      let arr = [];
      list.forEach(item => {
        arr.push(item.product_sku_id);
      });
      this.excludeIds = arr;
      this.isproduct = true;
    },
    /*删除商品*/
    deleteClick(e) {
      let curItem = this.form.product[e];
      for (let i = 0; i < this.form.product.length; i++) {
        let item = this.form.product[i];
        if (curItem.product_sku_id == item.product_sku_id) {
          if (this.type == 'edit' && e.tempProduct != true) {
            let product_sku_id = item.product_sku_id;
             this.form.product_del_ids.push(product_sku_id);
          }
          this.form.product.splice(i, 1);
          i--;
        }
      }
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/plus/shareholder/index/Relationproduct2.vue